module.exports = {
    RA_ZERO_QUESTION_ID: '702',
    RA_FOUR_QUESTION_ID: '104',
    SUITABILITY_TEST_STEP_0: 'SUITABILITY_TEST_STEP_0',
    SUITABILITY_TEST_CATEGORY_0: 'SUITABILITY_TEST_CATEGORY_0',
};
